import {
    DOWNLOAD_INVOICE_CSV,
    DOWNLOAD_INVOICE_CSV_FAILURE,
    DOWNLOAD_INVOICE_CSV_SUCCESS,
    SET_ALL_INVOICES,
    SET_CREATED_SIMPLE_INVOICE,
    SET_EDIT_INVOICE_DATA,
    SET_SIMPLE_INVOICE_DATA,
} from './actionTypes';

const initialState = {
    allInvoices: null,
    simpleInvoiceData: {},
    editSimpleInvoiceData: {},
    createdInvoice: {},
    error: '',
    downloadedInvoice: '',
    loading: false
};

const Invoices = (state = initialState, action) => {
    switch (action.type) {
        case SET_EDIT_INVOICE_DATA:
            state = { ...state, editSimpleInvoiceData: action.payload };
            break;
        case SET_CREATED_SIMPLE_INVOICE:
            state = { ...state, createdInvoice: action.payload };
            break;
        case SET_SIMPLE_INVOICE_DATA:
            state = { ...state, simpleInvoiceData: action.payload };
            break;
        case SET_ALL_INVOICES:
            state = { ...state, allInvoices: action.payload };
            break;
        case DOWNLOAD_INVOICE_CSV:
            state = { ...state, loading: true };
            break;
        case DOWNLOAD_INVOICE_CSV_FAILURE:
            state = { ...state, error: action.payload, loading: false };
            break;
        case DOWNLOAD_INVOICE_CSV_SUCCESS:
            state = { ...state, downloadedInvoice: action.payload, loading: false };
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
};

export default Invoices;
